<template>
    <div>
        <div>
            <el-table
                :header-cell-style="{
					background: 'rgba(229,244,255,1)',
					color: '#0077CC',
					fontWeight: 'bold'
				}"
                align="center"
                header-align="center"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="companyName" label="公司名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="contacts" label="联系人" header-align="center" align="center"></el-table-column>
                <el-table-column prop="telphone" label="电话" header-align="center" align="center"></el-table-column>
                <el-table-column prop="email" label="邮箱" header-align="center" align="center"></el-table-column>
                <el-table-column prop="industry" label="所属行业" header-align="center" align="center"></el-table-column>
                <el-table-column prop="city" label="所在城市" header-align="center" align="center"></el-table-column>
                <el-table-column prop="filesPaths" label="营业执照" header-align="center" align="center">
                    <template slot-scope="scope">
                        <img :src="httpUrl+'/disk/'+scope.row.filesPaths" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="remarks" label="备注" header-align="center" align="center"></el-table-column>
                <el-table-column label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="del(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="flex-end">
            当前 第 {{queryData.currentPage}} 页，共 {{queryData.pages}} 页 {{queryData.total}} 条记录
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.currentPage"
                :page-size="queryData.pageSize"
                layout="prev, pager, next, jumper"
                :total="queryData.total"
                style="padding: 45px; text-align:right;"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import {
    listByPage,//列表查询
    deleteMutil
} from "../../../api/join.js";
export default {
    name: "breadcrumbList",
    data() {
        return {
            httpUrl:process.env.VUE_APP_URL,
            tableData: [],
            dialogVisible: false,
            queryData: {
                currentPage: 1, //当前页
                pageSize: 10,
            },
            isAdd:0,
            form:{
                filePath:""
            },
            title:"",
        };
    },
    methods: {
        handleSizeChange(val) {
              this.queryData.pageSize = val;
              this.listByPageFun();
        },
        handleCurrentChange(val) {
              this.queryData.currentPage = val;
            this.listByPageFun()
        },
        //列表
        listByPageFun() {
            listByPage({
                currentPage: this.queryData.currentPage,
                pageSize: this.queryData.pageSize,
            })
                .then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data.list || [];
                        this.queryData.total = res.data.total;
                        this.queryData.pages = res.data.pages;
                    }else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                });
        },
        del(val){
            deleteMutil({ids:val}).then(res=>{
                if(res.code==200){
                        this.$message.success("删除成功！");
                        this.listByPageFun();
                    }
                    else{
                        this.$message(res.message);
                    }
                })
                .catch(err => {
            });
        },
    },
    mounted() {},
    created() {
        this.listByPageFun();
    },
    computed: {
    }
};
</script>

<style lang="less" scoped>
.el-table {
    margin-top: 20px;
    /deep/ th .cell {
        font-weight: bold;
    }
    .el-button--text {
        color: #197cda;
    }
    .ql-editor {
        min-height: 150px;
    }
}
.flex-between {
    display: flex;
    justify-content: space-between;
}
.primary {
    width: 80px;
    height: 30px;
    background: rgba(0, 145, 255, 1);
    box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
    border-radius: 4px;
    padding: 0;
}
.input_box {
    width: 300px;
    height: 36px;
    border: 1px solid rgba(153, 194, 255, 1);
    border-radius: 4px;
    input {
        width: 270px;
        height: 36px;
        line-height: 36px;
        font-style: italic;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        box-sizing: border-box;
        padding-left: 10px;
    }
}
.flex-end {
    display: flex;
    justify-content: flex-end;
    color: #999999;
    font-size: 14px;
    align-items: center;
    margin-top: 30px;
}
.avatar-uploader{
    .avatar-uploader-icon{
        padding:11px 25px;
        border-radius: 4px;
        border:1px #ccc solid;
    }
}
</style>
